<script>
import axios from '@/utils/axios';

export default {
 inject: ['setLoading'],  
 data() {
  return {
    errors: {},
    admin: [],
    banks: [],
    title: "Inventory",
    text: "Inventory",
    purchase_order: [],
    app_currency: '',
    text1: "Purchase Order",
  };
 },

 async mounted() {
  const public_token = this.$route.params.public_token;
  this.purchaseOrderByToken(public_token);
  this.app_currency = await this.$appCurrency();
 },

 methods: {

printPO(){
  const originalTitle = document.title;
  document.title = `PO-${this.purchase_order?.po_number || 'PurchaseOrder'}`;
  window.print();
  document.title = originalTitle; 
},

 async purchaseOrderByToken(public_token){
  this.errors = {};
  this.setLoading(true);
  try{
   const response = await axios.get(`inventory/purchase-orders/${public_token}/by-token`);
   this.purchase_order = response.data.data;
   if(this.purchase_order?.admin_id){
    this.adminDetail(this.purchase_order.admin_id);
    this.adminBanks(this.purchase_order.admin_id);
   }
  }catch(error){
   this.$swalToast(error.message, 'error');
  }finally{
   this.setLoading(false);
  }
 },

 async adminDetail(admin_id){
  try{
   const response = await axios.get(`admin/${admin_id}`);
   this.admin = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

 async adminBanks(admin_id){
  try{
   const response = await axios.get(`banks/${admin_id}`);
   this.banks = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

},

};
</script>

<style scoped>

body {
 font-family: 'Arial', sans-serif;
 background-color: #fff;
 margin: 0;
 padding: 0;
 font-size: 10.5px;
 color: #333333;
 line-height: 1.4;
}

table {
 border-collapse: collapse;
 border-spacing: 0;
 width: 100%;
}
td { vertical-align: top; padding: 0; }

.invoice-container {
 width: 100%;
 max-width: 210mm;
 margin: 15mm auto 0 auto; 
 background: #ffffff;
 padding: 0 10px 10px 10px;
}

.text-right { text-align: right; }
.text-center { text-align: center; }
.text-uppercase { text-transform: uppercase; letter-spacing: 0.05em; }
.font-bold { font-weight: 700; }
.font-heavy { font-weight: 800; }
.text-dark { color: #000000; }
.text-gray { color: #666666; }

.fs-10 { font-size: 10px; }
.fs-11 { font-size: 11px; }
.fs-12 { font-size: 12px; }
.fs-14 { font-size: 14px; }
.fs-20 { font-size: 20px; }
.fs-24 { font-size: 24px; }

.bordered-box { border: 1px solid #000000; }
.cell-padding { padding: 5px 6px; }

.header-box td {
 border: 1px solid #000000;
}
.header-title {
 background-color: #F5F5F5;
 border-bottom: 2px solid #000000;
 padding: 6px 0;
}

.address-detail-section { margin-top: 8px; }
.address-box {
 padding: 6px;
 border: 1px solid #000000;
 min-height: 70px;
}
.detail-table td { padding: 2px 0; }

.items-table { margin-top: 8px; }
.items-table thead th {
 background-color: #F5F5F5;
 color: #333333;
 padding: 6px 8px;
 font-size: 9.5px;
 text-transform: uppercase;
 text-align: left;
 font-weight: 600;
 border: 1px solid #000000;
}
.items-table tbody td {
 padding: 4px 8px;
 border: 1px solid #000000;
 color: #333333;
}

.totals-section { margin-top: 8px; page-break-inside: avoid; }

.totals-table {
  width: 100%;
  border-collapse: collapse !important;
  border-spacing: 0 !important;
}
.totals-table td {
  padding: 7px 10px !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
}
.po-total-label {
  color: #666666 !important;
  font-size: 10.5px !important;
  text-align: left !important;
  font-weight: 400 !important;
  border-bottom: 1px solid #e5e5e5 !important;
}
.po-total-val {
  font-weight: 700 !important;
  color: #000000 !important;
  font-size: 11.5px !important;
  text-align: right !important;
  border-bottom: 1px solid #e5e5e5 !important;
}
.po-grand-total td {
  background-color: #000000 !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  padding: 10px !important;
}
.po-grand-total .po-grand-label {
  text-align: left !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.po-grand-total .po-grand-val {
  text-align: right !important;
  font-size: 14px !important;
}

.amount-in-words { padding: 6px 8px; }

.pay-now-button {
 background-color: #000000;
 color: #ffffff;
 padding: 6px 12px;
 text-decoration: none;
 font-weight: bold;
 font-size: 10px;
 border: 1px solid #000000;
 display: inline-block;
 text-align: center;
}

.footer-line {
 margin-top: 15px;
 border-top: 1px dashed #CCCCCC;
 padding-top: 4px;
 font-size: 9px;
 color: #666666;
 text-align: center;
}

@media print {
.invoice-container {
 width: 210mm;
 height: 277mm;
 margin: 0 auto;
 padding: 10mm 5mm 5mm 5mm;
 box-sizing: border-box;
}
.totals-section, .items-table {
 page-break-inside: avoid !important;
}
  .no-print {
    display: none !important;
  }
}
</style>

<template>

 <div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-end page-breadcrumb mb-3 mt-3 no-print">
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">

    <span class="badge bg-warning p-2 me-3">{{ purchase_order.status }}</span>  

    <a href="javascript:void(0);" class="btn btn-dark align-items-center me-3" @click="printPO">
<i class="ti ti-download me-2"></i>Print</a>

   <!-- <div class="dropdown" v-if="!isExpired() && (purchase_order.status !== 'Paid')">
    <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"><i class="ti ti-grip-vertical me-2"></i> Action</button>
    <ul class="dropdown-menu">
      <li><a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#quotation_action" @click="$refs.invoiceModal.invoiceAction(purchase_order?.id, 'Paid')"> <i class="ti ti-check me-2"></i> Accept</a></li>
    </ul>
   </div> -->
   
 </div>

   </div>
 <!-- /Breadcrumb -->

<div class="invoice-container" style="position: relative;">

  <!-- Header -->
  <table width="100%" cellpadding="0" cellspacing="0" border="1" class="bordered-box" style="position: relative; z-index: 1;">
  <thead>
    <tr>
     <td colspan="2" class="header-title text-center font-bold fs-14 text-uppercase">Purchase Order</td>
    </tr>
  </thead>
    <tr>
    <td width="70%" style="border-right: 1px solid #000000; padding: 6px;">
    <div class="fs-14 font-bold text-dark text-uppercase" style="margin-bottom: 3px;">
    {{ admin?.company?.company_name }}
    </div>

    <div class="fs-10 text-gray" style="line-height: 1.3;">
    <template v-if="admin?.company?.address">
    Address:
    {{ admin.company.address }},
    {{ admin.company.city }}
    -
    {{ admin.company.pincode }}<br>
    <template v-if="admin.company.gst"><strong>GSTIN:</strong> {{ admin.company.gst }} | </template>
    <template v-if="admin.company.email"><strong>Email:</strong> {{ admin.company.email }}</template>
    </template>
    </div>
      </td>

      <td width="30%" style="padding: 6px;">
        <table width="100%" class="detail-table fs-11">
          <tr>
            <td class="text-gray" style="width: 50%;">PO No:</td>
            <td class="text-right font-bold">{{ purchase_order?.po_number }}</td>
          </tr>
          <tr>
            <td class="text-gray">Expected Date:</td>
            <td class="text-right font-bold">
              {{ purchase_order?.expected_date ? $formatDate(purchase_order.expected_date, 'DD MMM YYYY') : 'N/A' }}
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

  <!-- Bill To / Other Details -->
  <table width="100%" cellpadding="0" cellspacing="0" class="address-detail-section">
    <tr>
      <td width="50%" class="bordered-box" style="padding: 6px; border-right: none;">
        <div class="fs-10 text-uppercase font-bold text-dark" style="margin-bottom: 3px;">
          Vendor
        </div>
        <div class="fs-11 font-bold" style="text-transform:uppercase">
          {{ purchase_order?.vendor?.name }}
        </div>
        <div class="fs-10 font-bold" style="text-transform:uppercase">
          {{ purchase_order?.vendor?.mobile }}
        </div>
        <div class="fs-10 font-bold" style="text-transform:uppercase" v-if="purchase_order?.vendor?.email">
          {{ purchase_order?.vendor?.email }}
        </div>
        <div class="fs-10 text-gray" style="line-height: 1.3; margin-top: 3px;">
         <template v-if="purchase_order?.vendor?.address"> {{ purchase_order?.vendor?.address }}<br> </template>
          {{ purchase_order?.vendor?.city }}<span v-if="purchase_order?.vendor?.state">, {{ purchase_order?.vendor?.state }} </span> - {{ purchase_order?.vendor?.pincode }}
        </div>
        <div class="fs-10" style="text-transform:uppercase" v-if="purchase_order?.vendor?.gst_no">
          GSTIN: {{ purchase_order?.vendor?.gst_no }}
        </div>
      </td>
    </tr>
  </table>

  <!-- Items -->
  <table class="items-table bordered-box" cellspacing="0" cellpadding="0" style="position: relative; z-index: 1;">
    <thead>
      <tr>
        <th width="5%" class="text-center">S.No.</th>
        <th width="40%">Description of Goods/Services</th>
        <th width="10%" class="text-center">HSN/SAC</th>
        <th width="10%" class="text-center">Qty</th>
        <th width="10%" class="text-right">Rate</th>
        <th width="10%" class="text-center">Tax %</th>
        <th width="15%" class="text-right">Amount</th>
      </tr>
    </thead>
    <tbody>
     <tr v-for="(item, index) in purchase_order?.purchase_order_items || []" :key="item.id || index">
      <td class="text-center fs-10">{{ index + 1 }}</td>
       <td><strong class="text-dark fs-10">{{ item?.item?.name }}</strong></td>
        <td class="text-center fs-10 text-gray"> {{ item.hsn_code || 'N/A' }} </td>
        <td class="text-center fs-10"> {{ parseInt(item.quantity_ordered) }} {{ item?.item?.unit }} </td>
        <td class="text-right fs-10"> {{ parseFloat(item.unit_price || 0).toFixed(2) }} </td>
        <td class="text-center fs-10"> {{ item?.tax?.rate || 0 }}% </td>
        <td class="text-right font-bold fs-10 text-dark"> {{ parseFloat(item.taxable_amount || 0).toFixed(2) }} </td>
      </tr>

      <!-- Empty filler rows to keep height -->
      <tr v-for="n in Math.max(0, 5 - (purchase_order?.purchase_order_items?.length || 0))" :key="'empty-'+n">
        <td class="text-center fs-10">-</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>

  <!-- Totals / Terms / Signature -->
  <table width="100%" cellpadding="0" cellspacing="0" class="totals-section bordered-box" style="position: relative; z-index: 1;">
    <tr>
    <!-- Amount in words -->
    <td colspan="2" class="amount-in-words" style="border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 6px;">
      <div class="fs-10 text-uppercase font-bold text-dark" style="margin-bottom: 3px;">
        Amount Chargeable (in words)
      </div>
      <div class="fs-11 font-heavy text-dark" style="text-transform: capitalize;">
        {{ $amountInWords(purchase_order?.total_amount || 0) }} Only
      </div>
    </td>

    <!-- Right totals column -->
    <td width="35%" style="padding: 0; border-left: 1px solid #000000;">
    <table class="totals-table" width="100%" cellpadding="0" cellspacing="0">
      <tr>
        <td class="po-total-label">Subtotal</td>
        <td class="po-total-val">{{ parseFloat(purchase_order?.subtotal || 0).toFixed(2) }}</td>
      </tr>

      <tr v-if="parseFloat(purchase_order?.tax_amount || 0) > 0">
        <td class="po-total-label">Total Tax</td>
        <td class="po-total-val">{{ parseFloat(purchase_order.tax_amount || 0).toFixed(2) }}</td>
      </tr>

      <tr class="po-grand-total">
        <td class="po-grand-label">TOTAL</td>
        <td class="po-grand-val">
          {{ app_currency.code }} {{ parseFloat(purchase_order?.total_amount || 0).toFixed(2) }}
        </td>
      </tr>
    </table>
    </td>
    </tr>

    <tr>
      <!-- Notes -->
      <td width="100%" style="padding: 6px; border-bottom: 1px solid #000000; border-right: 1px solid #000000;">
        <div class="fs-10 font-bold text-dark" style="margin-bottom: 3px;">
          Notes
        </div>
        <div class="fs-10 text-gray" style="line-height: 1.3;">
          <template v-if="purchase_order?.notes">
            <div v-html="purchase_order.notes"></div>
          </template>
          <template v-else>
            Thank you for your business.
          </template>
        </div>
      </td>
    </tr>

    <!-- Signature -->
    <tr>
     <td colspan="3" class="text-right" style="padding: 6px;">
      <div style="height: 40px; margin-bottom: 5px; text-align: right;">
       <img v-if="admin?.company?.signature" :src="admin.company.signature_url" alt="Signature"
    style="height: 40px; width: auto; object-fit: contain;">
      </div>

      <div style="font-weight: bold; color: #000000; margin-top: 10px; margin-bottom: 5px;">
       For <strong>{{ admin?.company?.company_name }}</strong>
      </div>

      <div class="fs-10 text-dark" style="border-top: 1px solid #000000; display: inline-block; padding-top: 4px; min-width: 150px; text-align: center;">
       Authorized Signatory
      </div>
      </td>
    </tr>
  </table>

  <div class="footer-line">
    This is a computer generated purchase order.
  </div>
 </div>

  <!-- /Purchase Order -->

    <!-- <div class="d-flex justify-content-center align-items-center mb-4">
      <a href="javascript:void(0);" class="btn btn-primary d-flex justify-content-center align-items-center me-2"><i class="ti ti-printer me-2"></i>Print</a>
      <a href="javascript:void(0);" class="btn btn-white d-flex justify-content-center align-items-center border"><i class="ti ti-copy me-2"></i>Clone Invoice</a>
    </div> -->
  </div>

</template>